import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { faArrowAltCircleLeft, faArrowAltCircleRight } from "@fortawesome/free-regular-svg-icons";

import { LOGIN_PATH, LOGOUT_PATH } from "../../Constants/GlobalConstant";
import SearchBar from "../SearchBar/SearchBar";
import Logo from "../Logo/Logo";

import Button from "../../UI/Button/Button";
import LinkButton from "../../UI/Button/LinkButton";
import Alerts from "../Alerts/Alerts";

const NavBar = (props) => {
    const intl = useIntl();

    let authenticationRedirectLink = LOGIN_PATH;
    let authenticationLabel = intl.messages.loginButton;
    if (props.isAuthenticated) {
        authenticationLabel = intl.messages.logoutButton;
        authenticationRedirectLink = LOGOUT_PATH;
    }

    return (
        <nav className="navbar flex-row flex-nowrap" >
            <div className="d-flex align-items-center justify-content-between flex-grow-1" style={{ width: "280px" }}>
                <Logo />
                <Button
                    icon={props.status ? faArrowAltCircleRight : faArrowAltCircleLeft}
                    className="btn-icon btn-icon-primary btn-xl"
                    onClick={() => props.onMenuToggleClick()}
                    tooltipTitle={props.status ? intl.messages.showSidebar : intl.messages.hideSidebar}
                />
            </div>

            <div className="container-fluid pr-0">
                <div className="ml-3 flex-fill">
                    <SearchBar />
                </div>

                <div className="navbar float-right">
                    {props.isAuthenticated && false && <Alerts />}
                    
                    <LinkButton
                        to={authenticationRedirectLink}
                        label={authenticationLabel}
                        className="btn-login"
                    />
                </div>
            </div>
        </nav>
    );
}

NavBar.defaultProps = {
    isAuthenticated: false,
    status: false
}

NavBar.propTypes = {
    isAuthenticated: PropTypes.bool,
    status: PropTypes.bool,
    onMenuToggleClick: PropTypes.func
};

export default NavBar;